import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToolbarComponent } from 'src/app/core/components/toolbar/toolbar.component';
import { NavigationComponent } from 'src/app/core/components/navigation/navigation.component';

@Component({
  selector: 'app-dashboard-layout',
  templateUrl: './dashboard-layout.html',
  imports: [
    RouterOutlet,
    ToolbarComponent,
    NavigationComponent
  ],
  styleUrl: './dashboard-layout.scss'
})
export class DashboardLayoutComponent {

}
